import { isMobileWebView } from '../utils/helpers';

export const isiOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const isSafari = () => navigator.vendor.match(/apple/i);
export const isWindows = () =>
  /Win32|Win64|Windows|WinCE/.test(navigator.userAgent);

// Detect audio or video recording is supported
export const deviceSupportsAudioRecording = () => 'MediaRecorder' in window;

export const deviceSupportsVideoRecording = () => {
  if (isMobileWebView() || isiOS()) {
    return false;
  }
  return 'MediaRecorder' in window;
};

export const deviceSupportsScreenCapture = () => {
  if (isMobileWebView()) {
    return false;
  }
  return (
    'MediaStream' in window &&
    'MediaDevices' in window &&
    // @see https://github.com/microsoft/TypeScript/issues/33232
    (navigator.mediaDevices as any).getDisplayMedia
  );
};
